import styled from "styled-components";

export const GallerySection = styled.section`
  padding: 75px 0;
  min-height: 50vh;
  display: flex;
  align-items: center;
  /* background-color: ${(props) => props.background || "#f8f9fa"}; */

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: ${(props) => props.theme.colors.secondary};
  font-weight: 600;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionDescription = styled.p`
  font-size: 1.1rem;
  color: #666;
  line-height: 1.8;
  margin-bottom: 2rem;
  text-align: left;
  /* max-width: 600px; */
  margin-left: auto;
  margin-right: auto;
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(375px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
`;

export const GalleryItem = styled.div`
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 250px;
  background: ${(props) => props.background || "#6c757d"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  position: relative;
  overflow: hidden;
`;

export const ImageCaption = styled.div`
  padding: 1rem;
  background: white;
  text-align: center;
  font-weight: 500;
  color: ${(props) => props.theme.colors.secondary};
`;

// Lightbox/Modal Styles
export const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: ${(props) => (props.isOpen ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 2rem;
`;

export const LightboxContent = styled.div`
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    width: 105%;
  }
`;

export const LightboxImage = styled.div`
  background: transparent;
  width: 800px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  border-radius: 10px;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    width: 100%;
    height: 440px;
  }
`;

export const LightboxCaption = styled.div`
  font-size: 1.2rem;
  text-align: center;
`;

export const LightboxNav = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const NavButton = styled.button`
  background: ${(props) => props.theme.colors.primary};
  border: none;
  color: white;
  cursor: pointer;
  font-weight: 900;
  transition: all 0.3s ease;
  border-radius: 60px;
  padding: 10px 14px;

  &:hover {
    background: ${(props) => props.theme.colors.accent};
    transform: translateY(-2px);
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 16px;
  background: none;
  border: none;
  color: white;
  font-size: 3rem;
  cursor: pointer;
  padding: 0.5rem;

  &:hover {
    color: ${(props) => props.theme.colors.accent};
  }
`;

export const ImageCounter = styled.div`
  color: white;
  font-size: 1rem;
  margin: 0 1rem;
`;

export const ShowMoreButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;

export const ShowMoreButton = styled.button`
  background: ${(props) => props.theme.colors.primary};
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 1rem;
  border-radius: 60px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background: ${(props) => props.theme.colors.secondary};
  }
`;
